import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (Sentry.getCurrentHub().getClient()) {
      Sentry.captureException(error);
    }
    // Preserve console error for local debugging
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
